const moment = require("moment");

export default {
  namespaced: true,
  state: {
    token: "",
    todayDate: moment().format("DD-MM-YYYY"),
    tenantName: "",
    customerName: "",
    application: {},
    documents: {},
    dialog: {
      showAlerts: false,
      visible: false,
      title: "",
      message: "",
      buttons: {
        cancel: "",
        ok: ""
      }
    }
  },
  getters: {
    token: state => state.token,
    todayDate: state => state.todayDate,
    tenantName: state => state.tenantName,
    customerName: state => state.customerName,
    application: state => state.application,
    documents: state => state.documents,
    dialog: state => state.dialog
  },
  mutations: {
    saveToken: (state, token) => {
      state.token = token
    },
    saveTenantName: (state, tenantName) => {
      state.tenantName = tenantName
    },
    saveCustomerName: (state, customerName) => {
      state.customerName = customerName
    },
    saveApplication: (state, application) => {
      state.application = application
    },
    saveDocuments: (state, documents) => {
      state.documents = documents
    },
    saveDialog: (state, payload) => {
      state.dialog = payload
    }
  },
  actions: {
    saveToken: (context, token) => {
      context.commit("saveToken", token)
    },
    saveTenantName: (context, tenantName) => {
      context.commit("saveTenantName", tenantName)
    },
    saveCustomerName: (context, customerName) => {
      context.commit("saveCustomerName", customerName)
    },
    saveApplication: (context, application) => {
      context.commit("saveApplication", application)
    },
    saveDocuments: (context, documents) => {
      context.commit("saveDocuments", documents)
    },
    saveDialog: (context, payload) => {
      context.commit("saveDialog", _.merge(context.state.dialog, payload))
    }
  }
}
